/* eslint no-console:0 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'balloon-css';
import 'flatpickr/dist/flatpickr.css';

Array.prototype.findById = function (id) {
  for (let i = 0; i < this.length; i ++) {
    if (this[i].id === id) return this[i]
  }
  return {}
};
Array.prototype.eachSlice = function (size) {
  this.arr = []
  for (let i = 0, l = this.length; i < l; i += size) {
    this.arr.push(this.slice(i, i + size))
  }
  return this.arr
};
Array.prototype.sortBy = function(meth){
  return this.sort((a, b)=>a[meth] - b[meth])
}
Number.prototype.html = function(){
  return this.toString()==='Infinity' ? '∞' : this.toString()
}


import TurbolinksAdapter from 'vue-turbolinks'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'

axios.defaults.paramsSerializer= (params)=>Qs.stringify(params, {arrayFormat: 'brackets'})
axios.defaults.withCredentials = true
axios.interceptors.request.use(function (config) {
  config.headers['Accept-Language'] = I18n.locale
  config.headers.locale = I18n.locale
  config.headers['X-CSRF-Token'] = document.querySelector("meta[name='csrf-token']")?.content
  config.credentials = true
  if (config.url.startsWith('/api2/auto/') && config.params){
    if (config.params.organization_id){
      config.url = config.url.replace('/api2/auto/', '/api2/organization/')
    }else{
      config.url = config.url.replace('/api2/auto/', '/api2/family/')
    }
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});
Vue.use(VueAxios, axios)
import {store} from "code/store.js";
import {func_router} from "code/routes.js";
import base_mixin from "code/base_mixins.js"
import VueSanitize from "code/sanitize.js"


import linkify from 'vue-linkify'
import App from 'templates/app'
import { ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import { required, max,  alpha, confirmed, oneOf, regex, length, max_value, min_value} from 'vee-validate/dist/rules';
// vee-validate localization moved to base_mixin.js
extend('required', required)
extend('max', max)
extend('max_value', max_value)
extend('min_value', min_value)
extend('alpha', alpha) // used fo custom validation on the phone
extend('confirmed',confirmed)
extend('regex',regex)
extend('oneOf',oneOf)
extend('length',length)
// extend('customlength', {
//   validate(value, args) {
//     return args.arr.length >= args.length;
//   },
//   params: ['length','arr'],
//   computesRequired: true,
// });
extend('email', {
  validate(value, args) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const splitter = /[,;: ]+/
    const multiple = (args === void 0 ? {} : args).multiple

    if (multiple && !Array.isArray(value)) {
      value = String(value)
        .split(splitter)
        .map(emailStr => emailStr.trim());
    }

    if (Array.isArray(value)) {
      return value.every(val => re.test(String(val)));
    }

    return re.test(String(value));
  },
  params: ['multiple']
})

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

import FloatingLabel from "components/FloatingLabel"
import dropdown from "components/dropdown";
import unsaved_changes_alert from "components/unsaved_changes_alert";

Vue.use(TurbolinksAdapter)
Vue.use(VueSanitize, {allowedTags: process.env.ALLOWED_TAGS.split(",")});

Vue.directive('linkified', linkify)
Vue.mixin(base_mixin)
Vue.component('FloatingLabel', FloatingLabel)
Vue.component('dropdown', dropdown)
Vue.component('unsaved_changes_alert', unsaved_changes_alert)

function loadVue() {
  if (window.app){
    window.app.$destroy()
    window.vue_unsaved_changes = false
  }
  let el = document.querySelector("#vue-app")
  if (!el) return

  const app = new Vue({
    store,
    router: func_router(),
    el,
    render: h => h(App)
  });
  window.app = app
}

document.addEventListener('DOMContentLoaded', loadVue)
document.addEventListener('page:load', loadVue)
document.addEventListener('page:restore', loadVue)

// WCAG 4.1.3: Announce page changes to screen readers
function announcePageChange() {
  const announcer = document.querySelector('[data-page-announcer]');
  if (announcer) {
    // Use the page title for announcement
    announcer.textContent = document.title;
  }
}

document.addEventListener('DOMContentLoaded', announcePageChange)
document.addEventListener('page:load', announcePageChange)
document.addEventListener('page:restore', announcePageChange)
